import { openAuthenticationModal } from './openAuthenticationModal';
import { subscribeOnAuthentification } from './subscribeOnAuthentification';
import { IRequestAuthenticationParameters } from './types';
import { TThunkAction } from '../../types/redux';

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return dispatch => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      dispatch(subscribeOnAuthentification(parameters));
      dispatch(
        openAuthenticationModal({
          autoRefresh: false,
          alert: parameters?.alert ?? null,
          viewData: parameters?.viewData ?? null,
          source: parameters?.source ?? null,
        }),
      );
    }
  };
}
